import { render, staticRenderFns } from "./BlogPostCreate.vue?vue&type=template&id=48246199&scoped=true&"
import script from "./BlogPostCreate.vue?vue&type=script&lang=js&"
export * from "./BlogPostCreate.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostCreate.vue?vue&type=style&index=0&id=48246199&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48246199",
  null
  
)

export default component.exports